/* eslint no-console:1 */
import Selector from './Selector';

/**
 *
 * @type {Class}
 */
export default class SpecialSelector extends Selector {

  constructor(el) {

    super(el);

    this.el = el;
    this.isSorting = el.classList.contains('is-sorting-selector');
    this.isAmount = el.classList.contains('is-amount-selector');
    this.params = this.select.getAttribute('data-params');

    this.paramsObj = null;
    this.queryString = '';

    if (this.params) {

      try {

        this.paramsObj = JSON.parse(this.params);
      } catch (error) {

        throw new Error(`Can't convert parameters: ${error.message}`);
      }
    }

    if (this.paramsObj) {

      for (let param in this.paramsObj) {

        if (this.paramsObj.hasOwnProperty(param)) {

          this.queryString += `&${param}=${this.paramsObj[param]}`;
        }
      }
    }

    this.registerSpecialSelectorEvents();
  }


  /**
   *
   *  TODO:
   *    REWRITE ME IMMEDIATELY!!!!!!!
   *    no fucking need for 2 functions if we can simply exchange a single piece of sting in the onChange method
   */

  registerSpecialSelectorEvents() {

    if (this.isSorting) {
      this.select.addEventListener('change', this.onChangeSortingSelector.bind(this), false);
    }

    if (this.isAmount) {
      this.select.addEventListener('change', this.onChangeAmountSelector.bind(this), false);
    }
  }

  onChangeSortingSelector() {

    const option = this.select.querySelector('option:checked');
    let href = option.getAttribute('data-href');

    if (!href || href[0] === '#') {

      href = '';
    }

    window.location.href = href;
  }

  onChangeAmountSelector() {

    const option = this.select.querySelector('option:checked');
    let href = option.getAttribute('data-href');

    if (!href || href[0] === '#') {

      href = '';
    }

    window.location.href = href;
  }
};
